export default class Datetime {
  constructor (date) {
    this.info = {
      year: date.getFullYear(),
      month: pad(date.getMonth() + 1),
      date: pad(date.getDate()),
      hours: pad(date.getHours()),
      minutes: pad(date.getMinutes()),
      seconds: pad(date.getSeconds())
    };
  }

  toDateStr () {
    let { year, month, date } = this.info;
    return `${year}-${month}-${date}`;
  }

  toTimeStr () {
    let { hours, minutes, seconds } = this.info;
    return `${hours}:${minutes}:${seconds}`;
  }

  toDatetimeStr () {
    return `${this.toDateStr()} ${this.toTimeStr()}`;
  }
}

function pad (n) {
  return ('0' + n).slice(-2);
}



// WEBPACK FOOTER //
// ./src/plugins/Datetime.js